<template>
  <div 
    :class="[
      { 'loading-bg' : type == 'absolute' && loading },
    ]" 
    @click="eventStopChk"
  >
    <!-- <div v-if="loading"
      :class="[
        'loading-text',
        { 'lds-facebook' : type == 'absolute'}
      ]"
    >
      로딩중 ...
    </div> -->

    <clip-loader 
      :class="{ 'lds-facebook' : type == 'absolute'}" 
      :loading="loading" 
      :color="color" 
      :size="size"
      :width="width"
    />
  </div>
</template>


<script>

  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

  export default {
    components: {
      ClipLoader
    },

    data() {
      return {
        color: '#2e6fef',
        // color: 'white',
        size: '50px',
        width: '6',
        radius: '',
      }
    },

    methods: {
      eventStopChk(event) {
        if (this.loading) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      }
    },
    
    // watch: {
    //   loading(v) {
    //     if(v) {
    //       try {
    //         document.body.classList.add("stop-scrolling"); 
    //       } catch (error) {
    //         console.log('class exist')
    //       }
          
    //     }

    //     else {
    //       try {
    //         document.body.classList.remove("stop-scrolling"); 
    //       } catch (error) {
    //         console.log('class not found')
    //       }
          
    //     }
    //   }
    // },

    props: {
      loading: {
        type: Boolean,
        default: false,
      },
      type: {
        type: String,
        default: '',
      },
      backHide: {
        type: Boolean,
        default: true,
      }
    },
  }
</script>


<style>
/* .loading-text {
  width: 116px !important;
  font-size: 30px;
  color: white;
  font-weight: bold;
} */

.loading-bg {
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  z-index: 100000;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.lds-facebook {
  display: inline-block;
  position: absolute;
  z-index: 100001;
  width: 64px;
  height: 64px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>